var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"influencer-network-edit","toptitle":"Netzwerk bearbeiten","title":_vm.influencerNetwork.name,"width":400}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('influencer-network-form',{attrs:{"influencerNetwork":_vm.influencerNetwork,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }